<template>
  <div :class="`distribution${$theme?'':' eng'}`">
    <div class="line top"></div>
    <div class="line bottom"></div>
    <div class="title-line"></div>
    <div class="title">{{ $theme ? '国内分布' : 'DOMESTIC DISTRIBUTION' }}</div>
    <div class="list">
      <div :class="`city${$theme?' chn':''}`" v-for="item in list" :key="'city'+item.id">
        <div class="name">
          <span>{{ $theme ? item.province : item.provinceEng }}·{{ $theme ? item.city : item.cityEng }}</span>
        </div>
        <div class="address">
          <img src="@/assets/img/on-china-entropy/location.png">
          <span>{{ $theme ? item.address : item.addressEng }}</span>
        </div>
        <div class="img">
          <img :src="require(`@/assets/img/on-china-entropy/map/${item.imgName}.png`)">
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      list: [
        {
          id: 1,
          imgName: '北京',
          province: '北京',
          city: '朝阳',
          provinceEng: 'Beijing',
          cityEng: 'Chaoyang',
          addressEng: '6th Floor, Building A, Wangjing Science Park, 101 Middle Second Road, Lize',
          address: '利泽中二路101号望京科技园A座6层',
        }, {
          id: 2,
          imgName: '深圳',
          province: '深圳',
          city: '福田',
          provinceEng: 'Shenzhen',
          cityEng: 'Futian',
          addressEng: 'Room 1504-1, Building 3, Shenzhen New Generation Industrial Park, No. 136, Zhongkang Road',
          address: '中康路136号深圳新一代产业园3栋1504-1',
        }, {
          id: 3,
          imgName: '深圳龙岗',
          province: '深圳',
          city: '龙岗',
          provinceEng: 'Shenzhen',
          cityEng: 'Longgang',
          addressEng: '34th floor, Longgang Venture Capital Building, No.9 Tengfei Road, Longgang Central City',
          address: '龙岗中心城腾飞路9号龙岗创投大厦34层',
        }, {
          id: 4,
          imgName: '张家口',
          province: '河北',
          city: '张家口',
          provinceEng: 'Hebei',
          cityEng: 'Zhangjiakou',
          addressEng: '4 / F, Building 27, Phoenix Phase 2, Economic Development Zone',
          address: '经开区凤凰城2期27号楼4层',
        }, {
          id: 5,
          imgName: '湖州',
          province: '浙江',
          city: '湖州',
          provinceEng: 'Zhejiang',
          cityEng: 'Shenzhen',
          addressEng: 'Building 4, the first energy-saving Taihu Lake, Chuangye Avenue, Wuxing District',
          address: '吴兴区创业大道中国节能太湖首座4号楼',
        }
      ],
    };
  },
  props: {},
  components: {},
  computed: {},
  methods: {},
  created() {
  },
  mounted() {
  },

};
</script>

<style scoped lang="scss">
@import "./Index.scss";
</style>
